<!--
 * @Description:
 * @Author: luokang
 * @Date: 2023-12-12 10:57:58
-->
<template>
  <div class='step_three'>
    <div><img class="three_img" src="@/assets/images/bind_success.png" alt="绑定成功"></div>
    <p>{{ $lang('绑定成功') }}</p>
    <p>{{ $lang('已为您生成紧急恢复密钥') }}</p>
    <p class="step_error">
      <img src="@/assets/images/codeErr.png" alt="报错提示">
      <span>{{ $lang('如果你无法使用手机，可通过此密钥登录。请复制、打印或写下此密钥，并妥善保管。') }}</span>
    </p>
    <div class="three_key">{{ googleInfo.secretKey }}</div>
    <div class="copy_key" @click="copyHandle(googleInfo.secretKey)">{{ $lang('复制密钥') }}</div>
    <div class="bottom_text" @click="$emit('success')">
      <span>{{ $lang('已复制，进入系统') }}</span>
      <i class="el-icon-arrow-right"></i>
    </div>

  </div>
</template>
<script>
import { copyHandle } from '@/utils/util.js'
export default {
  components: {},
  props: {
    googleInfo: {
      type: Object,
      default: () => {}
    }
  },
  name: 'StepThree',
  data() {
    return {
      key: '5UWN 8LSX KG68 4I0D BUHL FZIR'
    }
  },
  computed: {},
  watch: {},
  methods: {
    copyHandle(value) {
      copyHandle(value)
    }
  },
  created() {

  },
  mounted() {

  }
}
</script>
<style scoped lang='scss'>
 /* @import url(); 引入css类 */
.step_three{
  display: grid;
  place-items: center;
  padding: 56px 0;
  p{
    margin: 0;
  }
  .three_img{
    width: 68px;
    height: 68px;
  }
  p:nth-child(2){
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Regular;
    text-align: center;
    color: #3c3c3c;
    margin:10px 0 13px;
  }
  p:nth-child(3){
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    text-align: center;
    color: #7a7a7a;
  }
  .step_error{
    display: flex;
    align-items: center;
    margin: 6px 0 30px;
    img{
      width: 12px;
      height: 12px;
      margin-right: 6px;
    }
    span{
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Regular;
      text-align: center;
      color: #ff1a2c;
    }
  }
  .three_key{
    min-width: 440px;
    white-space: nowrap;
    padding: 13px 0px;
    font-size: 18px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: 600;
    text-align: center;
    color: #1f1f1f;
    background: #ffffff;
    border-radius: 4px;
  }
  .copy_key{
    background-color: #FF1A2C;
    color:#fff;
    text-align: center;
    min-width: 440px;
    padding: 13px 0px;
    border-radius: 4px;
    cursor: pointer;
    margin: 16px 0 28px;
  }
  .bottom_text{
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: Regular;
    text-align: center;
    color: #ff1a2c;
    cursor: pointer;
  }
}
</style>
